import React from 'react';
import { Box } from '@mui/material';

import { LineScheduleGrid } from './LineScheduleGrid';

export function LineSchedule() {
  return (
    <Box sx={{ flexGrow: 1, height: 'inherit' }}>
      <LineScheduleGrid />
    </Box>
  );
}
